import axios from 'axios';

class TrackService {
  track(url:String, visitor_id:String) {
    return axios.post(import.meta.env.VITE_APP_API_URL + '/track', { url: url, visitor_id: visitor_id, timestamp: new Date().toUTCString() });
  }
}
export default new TrackService();
